var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconViolation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFEFE2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_697_25464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 8.8889C17.8023 8.8889 15.6541 9.54056 13.8269 10.7615C11.9997 11.9824 10.5756 13.7177 9.73458 15.748C8.89361 17.7783 8.67357 20.0123 9.1023 22.1677C9.53102 24.323 10.5893 26.3028 12.1432 27.8568C13.6971 29.4107 15.6769 30.4689 17.8322 30.8976C19.9876 31.3264 22.2217 31.1063 24.2519 30.2653C26.2822 29.4244 28.0176 28.0002 29.2385 26.173C30.4594 24.3458 31.111 22.1976 31.111 20C31.111 18.5409 30.8236 17.096 30.2652 15.748C29.7069 14.3999 28.8884 13.175 27.8567 12.1433C26.8249 11.1115 25.6 10.2931 24.2519 9.73468C22.9039 9.1763 21.459 8.8889 19.9999 8.8889ZM19.9999 28.8889C18.2419 28.8889 16.5233 28.3676 15.0615 27.3909C13.5997 26.4141 12.4604 25.0259 11.7876 23.4016C11.1149 21.7774 10.9388 19.9902 11.2818 18.2659C11.6248 16.5416 12.4714 14.9578 13.7145 13.7146C14.9577 12.4715 16.5415 11.6249 18.2658 11.2819C19.9901 10.9389 21.7773 11.115 23.4015 11.7877C25.0258 12.4605 26.414 13.5998 27.3908 15.0616C28.3675 16.5234 28.8888 18.242 28.8888 20C28.8888 22.3575 27.9523 24.6184 26.2853 26.2854C24.6183 27.9524 22.3574 28.8889 19.9999 28.8889Z",
    fill: "#DC2626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 25.5556C20.6136 25.5556 21.111 25.0581 21.111 24.4445C21.111 23.8308 20.6136 23.3333 19.9999 23.3333C19.3863 23.3333 18.8888 23.8308 18.8888 24.4445C18.8888 25.0581 19.3863 25.5556 19.9999 25.5556Z",
    fill: "#DC2626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 14.4444C19.7052 14.4444 19.4226 14.5615 19.2142 14.7699C19.0059 14.9783 18.8888 15.2609 18.8888 15.5556V21.1111C18.8888 21.4058 19.0059 21.6884 19.2142 21.8968C19.4226 22.1052 19.7052 22.2222 19.9999 22.2222C20.2946 22.2222 20.5772 22.1052 20.7856 21.8968C20.994 21.6884 21.111 21.4058 21.111 21.1111V15.5556C21.111 15.2609 20.994 14.9783 20.7856 14.7699C20.5772 14.5615 20.2946 14.4444 19.9999 14.4444Z",
    fill: "#DC2626"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_697_25464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.6667,
    height: 26.6667,
    fill: "white",
    transform: "translate(6.66663 6.66667)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViolation);
export default __webpack_public_path__ + "static/media/icon-violation.ed80fbe87d2a38042b3021e98091771e.svg";
export { ForwardRef as ReactComponent };